<section class="grid-container">
    <div class="grid-content section-content placement-center">
        <div [ngClass]="{'grid-double-column width-md': true, 'revert': MediaTextInfo.showRevert}">
            <div [ngClass]="{'media-container': true, 'mask-pc': MediaTextInfo.showMaskPC}">
                <img class="media-primary" src="{{ MediaTextInfo.imageSrc }}" alt="{{ MediaTextInfo.title }}"/>
                <img class="media-secondary" *ngIf="MediaTextInfo.showImageSecondary" src="../../../assets/images/mb.webp" alt="webGIS"/>
            </div>
            <div>
                <p class="heading-md font-regular gutter-md">
                    {{ MediaTextInfo.title }}
                </p>
                <div [innerHTML]="MediaTextInfo.description" class="font-thin">
                </div>
                <div *ngIf="MediaTextInfo.showButton" class="section-buttons">
                    <a href="{{ MediaTextInfo.buttonLink }}" [attr.target]="MediaTextInfo.openInNewTab ? '_blank' : null" class="btn outlined dark">
                        {{ MediaTextInfo.buttonText }}
                    </a>
                </div>
            </div>    
        </div>
    </div>
</section>